import { getPatternStyles, patternFns, __spreadValues, __objRest } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const tilesConfig = {
transform(props) {
  const _a = props, { columns = 3, rows, gutter: gutter2 = "md", direction } = _a, rest = __objRest(_a, ["columns", "rows", "gutter", "direction"]);
  return __spreadValues({
    display: "grid",
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gridAutoRows: "1fr",
    gap: gutter2,
    gridAutoFlow: direction === "vertical" ? "column" : "row",
    gridTemplateRows: direction === "vertical" ? `repeat(${rows}, 0fr)` : "none"
  }, rest);
}}

export const getTilesStyle = (styles = {}) => {
  const _styles = getPatternStyles(tilesConfig, styles)
  return tilesConfig.transform(_styles, patternFns)
}

export const tiles = (styles) => css(getTilesStyle(styles))
tiles.raw = getTilesStyle